import { Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { AuthService } from "../_services/auth.service";
import { Auth, authState } from "@angular/fire/auth";
import packageJson from '../../../package.json';
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton } from "@angular/material/button";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    imports: [MatToolbar, RouterLink, MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem]
})
export class HeaderComponent {
    private auth = inject(AuthService);
    private fireAuth = inject(Auth);

    version = packageJson.version;
    title = "Jeans";
    authed = this.auth.authed;

    private fireUser = toSignal(authState(this.fireAuth));
    userImage = computed(() => this.fireUser()?.photoURL ?? null);

    onImageError(event: Event) {
        (event.target as HTMLImageElement).src = 'assets/icons/icon-72x72.png';
    }

    logout() {
        this.auth.doLogout();
    }
}
